export default __webpack_public_path__ + "static/media/atom_icon.2c9ee82d.png";